import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop } from '@stencil/core';
import wcShared from '@web-components/shared';
// eslint-disable-next-line @typescript-eslint/naming-convention
import DOMPurify from 'dompurify';

@Component({
  tag: 'chat-message-faqs-component',
  styleUrl: 'chat-message-faqs-module.scss',
  shadow: true,
})
export class ModuleChatMessageFaqs {
  @Prop() readonly message: IWCChatMessage;

  @Event() openSupportModuleFaq: EventEmitter<number>;

  private openFaq(event, id: number) {
    event.preventDefault();
    this.openSupportModuleFaq.emit(id);
  }

  render() {
    return (
      <Host>
        <div class="message-faqs">
          <div class="message-faqs-title">
            <img
              src={getAssetPath('./../assets/icons/question-faq.svg')}
              alt={wcShared.translate('Questions frequentes')}
            />
            <span>{this.message?.title}</span>
          </div>
          <div class="message-faqs-list">
            <ul>
              {(this.message?.action as IWCChatMessageValue[])?.map((faq) => {
                return (
                  <li>
                    <img src={getAssetPath('./../assets/icons/play.svg')} />
                    <a
                      href={`https://faq.infomaniak.com/${faq.value}`}
                      onClick={(event) => this.openFaq(event, faq.value)}
                      innerHTML={DOMPurify.sanitize(String(faq.label))}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Host>
    );
  }
}
